<div class="modal-content">
  @if (showSearch()) {
    <div class="modal-header d-flex justify-content-between">
      <h3>Staff Search</h3>
      <div>
        <button type="button" class="btn btn-outline-primary btn-sm me-2" (click)="clearSearchForm()">Clear</button>
        @if (showCreateButton() && canLeaCreatePersons && lea2WorkforceManagementEnabled()) {
          <button type="button" class="btn btn-primary btn-sm me-2" (click)="toggleShowSearch(null)">
            Add New Person
          </button>
        }
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
      </div>
    </div>
    <div class="modal-body m-2">
      <cert-lea-staff-search
        [previousSearchRequest]="getSearchQuery()"
        [showCreateButton]="showCreateButton()"
        (searchExecuted)="onSearchExecuted($event)"
      ></cert-lea-staff-search>
    </div>
  }
  @if (!showSearch()) {
    <div class="modal-header d-flex justify-content-between">
      <h3>Add New Person</h3>
      <div class="d-flex">
        <button type="button" class="btn btn-primary btn-sm me-2" (click)="toggleShowSearch(null)">Search</button>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="close()"></button>
      </div>
    </div>
    @if (leaCodeId(); as leaCodeId) {
      <cert-workforce-create-person-step
        [leaCodeId]="leaCodeId"
        [searchedEin]="createPersonSeed()?.searchedEin ?? ''"
        [initialIdentity]="createPersonSeed()?.identity ?? null"
        [dateOfBirth]="createPersonSeed()?.dateOfBirth"
        (personReady)="onPersonReady($event)"
        (cancelled)="close()"
        (back)="toggleShowSearch(null)"
      ></cert-workforce-create-person-step>
    }
  }
</div>
